var map = {
	"./font/fons_1.otf": "u5Zg",
	"./font/fons_2.otf": "Y/2f",
	"./font/fons_3.ttf": "bO7M",
	"./greytabbt.png": "qRem",
	"./logo.png": "7Otq",
	"./tabbt2022.png": "7zZK",
	"./tabbt2023_1.png": "FLlA",
	"./tabbt2023_2.png": "C5tH"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 1